import { Button, Card, CardContent, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton, Typography } from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import HistoryIcon from '@material-ui/icons/History';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import axios from 'src/utils/axios';
import UrunTarihce from '../../components/ProductHistoryCenter';
import Tarihce from '../WorkOrder/History';
import Sondaj from '../WorkOrder/Sondaj';
import logger from 'src/utils/logger';
const useStyles = makeStyles((theme) => ({
  root: {},

  CentralRightButton: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
  submitButtonCentral: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  dividerPaper: {
    backgroundColor: '#FF9800'
  },
  valueCentral: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeCentral: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchCentral: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconCentral: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputCentral: {
    flexGrow: 1
  },
  searchButtonCentral: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  PaperControlTopCentral: {
    marginTop: theme.spacing(1)
  },
}));


function CentralPaperDetail({ className, item, Loading, handleCloseDetail }) {
  const classes = useStyles();
  const [urunTarihceAcCentral, seturunTarihceAcCentral] = React.useState(false);
  const [UrunDataCentral, setUrunDataCentral] = React.useState({});
  const [OpenServicePaperHistory, setOpenServicePaperHistory] = React.useState(false);
  const [FisNo, setFisNo] = React.useState(0);
  const [PaperData, setPaperData] = React.useState([]);
  const [Loadingg, setLoading] = React.useState(false);
  const [tarihce,setTarihce] = React.useState({});
  const [displayDetail, setDisplayDetail] = React.useState(false);
  const [, setDetailData] = React.useState({});
  const [, setUyari] = React.useState(false);
  const [, setUyariTip] = React.useState('');
  const [, setUyariAciklama] = React.useState('');

  const fncUrunTarihceAcCentral = () => {
    let jobCentral = {
      UYIL: parseInt(item.UYIL),
      UDONEM: parseInt(item.UDONEM),
      SERINO: parseInt(item.SERINO),
      NITELIK_KODU: parseInt(item.NITELIK_KODU),
      KUL_MODEL_KODU: item.KUL_MODEL_KODU,
    }
    setUrunDataCentral(jobCentral);
    seturunTarihceAcCentral(true);
  }

  const fncFisTarihceAcCentral = () => {
    setFisNo(item.FIS_NO);
    setOpenServicePaperHistory(true);
  }

  const SondajDurumAc = () => {
    
      setDisplayDetail(true);
      setDetailData({});
      setLoading(true);
      axios.get('/GetArtemisYerindeSondaj/'+item.FIS_NO).then((response) => {
        const PaperCC = response.data;
        
        setPaperData(PaperCC);
        getTarihce();
      }).catch(error => {
        setUyariTip("error");
        setUyariAciklama("Yetkiniz bulunmamaktadır!...");
        setUyari(true);
        setLoading(false);
              logger.error("Hata detayı:", error.message);
      });
    
  };
  const getTarihce = () => {
     
    axios.get('/GetArtemisSondajTarihce/'+item.FIS_NO).then((response) => {
      const PaperCC = response.data;
      setTarihce(PaperCC);
      setLoading(false);
    }).catch(error => {
            logger.error("Hata detayı:", error.message);
    });
  
};

  const handleCloseSondaj = () => {
    setDisplayDetail(false);
  };
  const handleRefreshSondaj = () =>{
    setDisplayDetail(true);
    SondajDurumAc();
    
    
  }
  const handleCloseServicePaperHistory = () => {
    setOpenServicePaperHistory(false);
  };
  return (
    <div>
      <Card className={clsx(classes.root, className)}>
        <CardContent className={classes.contentCentral}>
          <div className={classes.innerCentral}>
            {Loading ?
              <CircularProgress
                status={'loading'}
                style={{ marginLeft: '50%' }}
              />
              :
              <Grid container spacing={1}>
                <Grid item xs={2} sm={2}>
                  <IconButton
                    color="primary"
                    onClick={() => handleCloseDetail()}
                    alignItems="left"
                    size="small">
                    <ArrowBackIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={10} sm={10}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={fncFisTarihceAcCentral}
                    className={classes.CentralRightButton}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                  >
                    Fİşİn Durum Tarİhçesİ
                   </Button>
                </Grid>

                
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>FişNo</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.FIS_NO}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>ÇağrıTarih</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.CAGRI_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>İşlemTarih</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ISLEM_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Bölge</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.BOLGE}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Servis</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SERVIS_KODU} {item.SERVIS}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Teknisyen</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.KUL_TEK_KODU} {item.TEKNISYEN}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>BaşvuruNedeni</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.BASVURU_NEDENI}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>Randevu</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.RANDEVU_TARIHI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>Durum</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.DURUM}
                  </Typography>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Typography variant="caption" display="block" >
                    <b>GarantiTip</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.GARANTI_TIPI}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>ModelKodu</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.KUL_MODEL_KODU}
                  </Typography>
                </Grid>
                <Grid item xs={9} sm={9}>
                  <Typography variant="caption" display="block" >
                    <b>Model</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MODEL}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Marka</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MARKA}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Uyıl</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.UYIL}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>Udonem</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.UDONEM}
                  </Typography>
                </Grid>
                <Grid item xs={3} sm={3}>
                  <Typography variant="caption" display="block" >
                    <b>SeriNo</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SERINO}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Adı</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ADI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Soyadı</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.SOYADI}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Telefon</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.TEL1} {item.TEL2}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>İl</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.IL}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>İlçe</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ILCE}
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Typography variant="caption" display="block" >
                    <b>Mahalle</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MAHALLE}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Başvuru Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.BASVURU_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Çağrı Merkezi Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.CAGRI_MERKEZI_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} className={classes.PaperControlTopCentral} >
                  <Typography variant="caption" display="block">
                    <b>Sonuç Notu</b>
                  </Typography>
                  <Typography variant="subtitle2">
                    {item.SONUC_NOTU}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>Hizmetler</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.HIZMETLER}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>İşçilikler</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.ISCILIKLER}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Typography variant="caption" display="block" >
                    <b>Malzemeler</b>
                  </Typography>
                  <Typography variant="subtitle2" >
                    {item.MALZEMELER}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Divider style={{ backgroundColor: '#FF9800' }} />
                </Grid>
                <br />
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={fncUrunTarihceAcCentral}
                    className={classes.submitButtonCentral}
                    endIcon={<HistoryIcon>Gönder</HistoryIcon>}
                  >
                    Ürüne Verİlmİş Hİzmetler
                </Button>
                </Grid>
              </Grid>


            }
          </div>
          <Divider />
          {
            (urunTarihceAcCentral)
              ? <UrunTarihce UrunData={UrunDataCentral}></UrunTarihce>
              : <div></div>
          }
        </CardContent>
      </Card>
      <Dialog
        fullScreen={true}
        open={OpenServicePaperHistory}
        onClose={handleCloseServicePaperHistory}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Fiş Durum Tarihçesi
        </DialogTitle>
        
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Tarihce FisNo={FisNo} readonly={true} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={handleCloseServicePaperHistory}>
              Kapat
            </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullScreen={true}
        open={displayDetail}
        onClose={handleCloseSondaj}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          Sondaj Durum
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Sondaj items={PaperData}
                    tarihce={tarihce}
                    Loading={Loadingg}
                    className={classes.CentralPaperControl}
                    handleCloseSondaj={handleCloseSondaj}
                    handleRefreshSondaj={handleRefreshSondaj}/>
          </DialogContentText>
        </DialogContent>
        <Divider />
        <DialogActions>
        
     

          <Button
              variant="contained"
              color="secondary"
              endIcon={<CloseIcon>Close</CloseIcon>}
              onClick={handleCloseSondaj}>
              Kapat
            </Button>
        </DialogActions>
      </Dialog>
    </div >
  );
}

CentralPaperDetail.propTypes = {
  className: PropTypes.string
};

export default CentralPaperDetail;
